var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout-page',{staticClass:"page",attrs:{"bg":"white","tabbar":""}},[_c('div',{staticClass:"page-container about",domProps:{"innerHTML":_vm._s(_vm.data)}}),_c('tabbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }